export const API_URLS = {
	GET_FAQ_ITEMS: "faq",
	POST_FAQ_ITEM: "faq",
	DELETE_FAQ_ITEM: (id: string) => `/faq/${id}`,
	UPDATE_FAQ_ITEM: "faq"
};

export const prefilledPrices = [0.99, 1.99, 4.99, 14.99, 19.99, 24.99];
